import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { computed, observable } from 'mobx';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import BaseStore from '@src/utils/store/base-store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';
import { jumpPage } from '@src/utils/common-util';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData()?.main?.wordScreen || {};
const language = getLanguageByPath();

class SeventhPageStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      autoplay: false,
      loop: true,
      loopAdditionalSlides: 1,
      draggable: true
    }
  });

  @observable
  layerData = {
    worldViewList: [],
    config: {}
  };

  @observable pageLocalesData = pageLocalesData;

  @observable
  localData = {
    viewDetailBtn: require(`./images/${language}/detail-btn.png`)
  };

  @observable nextTitle = '';

  @computed
  get nextSlideTitle() {
    const { worldViewList } = this.layerData;
    if (this.baseSwiperStore.activeIndex === worldViewList.length - 1) {
      return worldViewList[0].world_part_title;
    }
    return worldViewList[this.baseSwiperStore.activeIndex + 1].world_part_title;
  }

  toDetail() {
    if (!IS_DEV_ENV) {
      const url = '/world-view.html';
      jumpPage(url, '#/');
    } else {
      this?.redirect('/world-view');
    }
  }

  use() {
    super.use();

    const funlinkData = useLayerData('part7');
    useEffect(
      () => {
        if (funlinkData) {
          this.layerData = funlinkData;
        }
      },
      [funlinkData]
    );
  }
}

export default SeventhPageStore;
